import { InvoiceStatus } from "enums/InvoiceStatus";
import { useMemo } from "react";

interface InvoiceStatusDetails {
  isInvoiceEditable: boolean;
  isInvoiceSendable: boolean;
  shouldNotShowUncancel: boolean;
  isInvoiceSent: boolean;
  isPaid: boolean;
  isCanceled: boolean;
  isPaymentProcessing: boolean;
  isFailedPayment: boolean;
  isEstimate: boolean;
  isSentOrFailed: boolean;
}

/** Pure form, for callers needing details per row rather than per render. */
export const getInvoiceStatusDetails = (
  status: InvoiceStatus,
): InvoiceStatusDetails => {
  let isEstimate = [
    InvoiceStatus.ESTIMATE,
    InvoiceStatus.ESTIMATE_APPROVED,
    InvoiceStatus.ESTIMATE_REJECTED,
  ].includes(status);

  let isInvoiceEditable =
    status === InvoiceStatus.DRAFT ||
    status === InvoiceStatus.PENDING ||
    status === InvoiceStatus.SENT ||
    isEstimate;

  let isInvoiceSendable =
    status === InvoiceStatus.PENDING ||
    status === InvoiceStatus.SENT ||
    isEstimate;

  let isPaid =
    status === InvoiceStatus.PAID || status === InvoiceStatus.COMPLETE;

  let isCanceled = status === InvoiceStatus.CANCELED;

  let shouldNotShowUncancel = !isCanceled;

  let isInvoiceSent = status === InvoiceStatus.SENT;

  let isPaymentProcessing = status === InvoiceStatus.PROCESSING_PAYMENT;

  let isFailedPayment = status === InvoiceStatus.PAYMENT_FAILED;

  let isSentOrFailed = isInvoiceSent || isFailedPayment;

  return {
    isInvoiceEditable,
    isInvoiceSendable,
    shouldNotShowUncancel,
    isInvoiceSent,
    isPaid,
    isCanceled,
    isPaymentProcessing,
    isFailedPayment,
    isEstimate,
    isSentOrFailed,
  };
};

const useGetInvoiceStatusDetails = (
  status: InvoiceStatus,
): InvoiceStatusDetails =>
  useMemo(() => getInvoiceStatusDetails(status), [status]);

export default useGetInvoiceStatusDetails;
